var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestimonialarrowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 12,
    viewBox: "0 0 30 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49986 10.2861L4.51177 7.21259H30V4.7881H4.51093L7.49936 1.71385L5.83282 0L0 6.00035L5.83282 12L7.49986 10.2861Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialarrowicon);
export default __webpack_public_path__ + "static/media/testimonial arrow icon.b031781978b630f414d22eb4a52f7334.svg";
export { ForwardRef as ReactComponent };